import React from 'react';

/**
 * Bordered surface with an optional uppercase header. Used for each
 * panel on the Overview tab (Project Information, Description & Scope,
 * Project Health, Project Settings).
 *
 * Props:
 *   title    — uppercase eyebrow text; omit to skip header
 *   hint     — optional right-aligned hint text rendered next to title
 *   action   — optional right-aligned action node (e.g. an icon button)
 *   padded   — boolean; default true. False omits body padding so the
 *              caller can control it (used by Health which has nested
 *              subsections).
 *   children — body content
 */
export default function Card({ title, hint, action, padded = true, children, style }) {
  return (
    <div
      style={{
        background: 'var(--bg-surface)',
        border: '1px solid var(--border-subtle)',
        borderRadius: 12,
        boxShadow: 'var(--shadow-sm)',
        ...style,
      }}
    >
      {(title || hint || action) && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '12px 16px 10px',
            borderBottom: '1px solid var(--border-subtle)',
          }}
        >
          {title && (
            <span
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: 'var(--text-1)',
                letterSpacing: '0.04em',
                textTransform: 'uppercase',
              }}
            >
              {title}
            </span>
          )}
          {hint && (
            <span style={{ fontSize: 13, color: 'var(--text-3)', fontWeight: 500 }}>
              {hint}
            </span>
          )}
          {action && <div style={{ marginLeft: 'auto' }}>{action}</div>}
        </div>
      )}
      <div style={padded ? { padding: 16 } : undefined}>{children}</div>
    </div>
  );
}
